import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Member } from "@shared/models/member";
import { DropdownModule } from "primeng/dropdown";
import { RadioButtonModule } from "primeng/radiobutton";

@Component({
  selector: "app-user-consent",
  standalone: true,
  imports: [CommonModule, DropdownModule, TranslateModule, ReactiveFormsModule, RadioButtonModule],
  templateUrl: "./user-consent.component.html",
  styleUrl: "./user-consent.component.scss",
})
export class UserConsentComponent implements OnChanges {
  private static readonly EMAIL_CONSENT = "emailConsent";
  private static readonly SMS_CONSENT = "smsConsent";

  @Input({ required: true }) isEditMode = false;
  @Input({ required: true }) member!: Member | undefined;
  @Input({ required: true }) isFirstContract = false;

  disabled!: boolean;

  userConsent = new FormGroup({
    emailConsent: new FormControl(false),
    smsConsent: new FormControl(false),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["member"] && this.member) {
      this.updateFormValuesFromMember();
    }

    if (changes["isEditMode"]) {
      this.updateFieldsAccessibility();
    }
  }

  private updateFormValuesFromMember(): void {
    this.userConsent.patchValue({
      emailConsent: this.member?.isEmailConsents ?? false,
      smsConsent: this.member?.isSmsConsents ?? false,
    });
  }

  private updateFieldsAccessibility() {
    this.disabled = !(this.isFirstContract && this.isEditMode);
    if (this.disabled) {
      this.userConsent.controls[UserConsentComponent.EMAIL_CONSENT].disable();
      this.userConsent.controls[UserConsentComponent.SMS_CONSENT].disable();
    } else {
      this.userConsent.controls[UserConsentComponent.EMAIL_CONSENT].enable();
      this.userConsent.controls[UserConsentComponent.SMS_CONSENT].enable();
    }
  }

  getFormData(): any {
    return this.userConsent.value;
  }
}
